import { useSessionManager } from "@/hooks/useSessionManager";
import { SessionWarningDialog } from "./SessionWarningDialog";

/**
 * SessionManager component - handles session timeout warnings
 * This should be rendered once at the app level (in Layout or App)
 */
export const SessionManager = () => {
  const { showWarning, warningSecondsLeft, extendSession } = useSessionManager();

  return (
    <SessionWarningDialog
      open={showWarning}
      secondsLeft={warningSecondsLeft}
      onExtend={extendSession}
    />
  );
};
